import React from 'react';
import { Column } from '@ant-design/charts';
import moment from 'moment';

const TransactionHistoryChart = ({ journals }) => {
  const grouped = journals.reduce((acc, curr) => {
    const dateLabel = moment(curr.created).format('DD MMM');
    const dateValue = moment(curr.created).format('YYYY-MM-DD');
    const type = curr.type; // "Debit" or "Credit"
    const key = `${dateValue}_${type}`;
    if (!acc[key]) {
      acc[key] = { date: dateLabel, sortDate: dateValue, type, amount: 0 };
    }
    acc[key].amount += parseFloat(curr.amount);
    return acc;
  }, {});

  const data = Object.values(grouped).sort((a, b) => a.sortDate.localeCompare(b.sortDate));

  const config = {
    data,
    isGroup: true,
    xField: 'date',
    yField: 'amount',
    seriesField: 'type',
    color: ['#007bff', '#dc3545'], // Blue for Debit, Red for Credit
    label: {
      position: 'middle',
      layout: [
        { type: 'interval-adjust-position' },
        { type: 'interval-hide-overlap' },
        { type: 'adjust-color' },
      ],
    },
    legend: {
      position: 'top-left',
    },
    xAxis: {
      label: {
        autoRotate: false,
      },
    },
  };

  return <Column {...config} style={{ height: '300px' }} />;
};

export default TransactionHistoryChart;
